var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{attrs:{"variant":"warning","show":""}},[_vm._v(" This "+_vm._s(_vm.isProject ? 'project' : 'scenario')+" is currently running and cannot be modified at this time. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }